import { Team, User } from 'src/components/types';

export const urls = {
  api: {
    v20: {
      code(owner: User | Team) {
        return `/!api/2.0/${owner.type}s/${owner.uuid}/search/code`;
      },
    },
  },
  external: {
    docs: 'https://confluence.atlassian.com/bitbucket/code-search-in-bitbucket-873876782.html',
  },
  ui: {
    search(workspaceSlug?: string) {
      if (workspaceSlug) {
        return `/${workspaceSlug}/workspace/search`;
      }
      return '/search';
    },
  },
};
